/** Angular */
import { Injectable } from '@angular/core';
/** Rxjs */
import { Observable } from 'rxjs';
/** Models */
import { DsRole } from '../models/ds-role';
import { BydModel } from '@sixense/byd-core-service';
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';

@Injectable({
  providedIn: 'root',
})
export class DsProjectRolesService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get all roles.
   *
   * @param  prjId Project ID
   * @returns Observable type `<BydModel<DsRole>>`
   */
  public getRoles(prjId: number): Observable<BydModel<DsRole>> {
    this.path = `/projects/${prjId}/roles`;
    return this.getModels<DsRole>();
  }

  /**
   * Get role rights.
   *
   * @param  prjId Project ID
   * @param  roleId Role ID
   * @returns Observable type `<number[]>`
   */
  public getRoleRights(prjId: number, roleId: number): Observable<number[]> {
    this.path = `/projects/${prjId}/roles/${roleId}/rights`;
    return this.get<number[]>();
  }

  /**
   * Add new right to a role.
   *
   * @param  prjId Project ID
   * @param  roleId Role ID
   * @param  rightId Right ID
   * @returns Observable type `<boolean>`
   */
  public addRoleRight(prjId: number, roleId: number, rightId: number): Observable<boolean> {
    this.path = `/projects/${prjId}/roles/${roleId}/rights/${rightId}`;
    return this.post<boolean>();
  }

  /**
   * Delete right from a role.
   *
   * @param  prjId Project ID
   * @param  roleId Role ID
   * @param  rightId Right ID
   * @returns Observable type `<boolean>`
   */
  public deleteRoleRight(prjId: number, roleId: number, rightId: number): Observable<boolean> {
    this.path = `/projects/${prjId}/roles/${roleId}/rights/${rightId}`;
    return this.delete<boolean>();
  }

  /**
   * Create DsRole instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `DsRole` instance.
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public createNewInstance(jsonObject: any): DsRole {
    return new DsRole(jsonObject);
  }
}
